import React from 'react';

import { SegmentChipTag } from './styles';

interface SegmentChipItemProps {
	label: string;
	segmentId: string;
	disabled?: boolean;
	onRemove: (segmentId: string) => void;
}

export function SegmentChipItem({
	label,
	segmentId,
	disabled = false,
	onRemove
}: Readonly<SegmentChipItemProps>): JSX.Element {
	function handleClose(event: React.MouseEvent<HTMLElement>): void {
		event.preventDefault();
		onRemove(segmentId);
	}

	return (
		<SegmentChipTag closable={!disabled} onClose={handleClose}>
			{label}
		</SegmentChipTag>
	);
}
